const ServerGridConfig = {
	rowHeight: 35,
	headerHeight: 40,
	options: {
		rowModelType: 'serverSide',
		animateRows: true,
		pagination: true,
		paginationPageSize: 100,
		cacheBlockSize: 100,
		rowHeight: 35,
		blockLoadDebounceMillis: 500,
		suppressContextMenu: true,
	},
	defaultColDef: {
		suppressMenu: true,
		resizable: true,
		sortingOrder: ['asc', 'desc'],
		filter: 'agTextColumnFilter',
		filterParams: {
			suppressAndOrCondition: true,
			debounceMs: 1000,
		},
		floatingFilter: false,
		minWidth: 200,
		flex: 1,
		cellStyle: { textAlign: 'left' },
	},
	columnTypes: {
		actionColumn: {
			cellRenderer: 'ActionRenderer',
		},
	},
};

const LocalGridConfig = {
	rowHeight: 35,
	headerHeight: 40,
	options: {
		animateRows: true,
		pagination: true,
		paginationPageSize: 50,
	},
	defaultColDef: {
		suppressMenu: true,
		resizable: false,
		sortingOrder: ['asc', 'desc'],
		filter: 'agTextColumnFilter',
		filterParams: {
			suppressAndOrCondition: true,
			// trimInput: true,
			// debounceMs: 2000
		},
		floatingFilter: true,
		minWidth: 200,
		flex: 'auto',
		cellClass: 'custom__cell',
		// autoHeight: true,
		// rowHeight=60
		cellStyle: { textAlign: 'left' },
	},
	components: {},
	columnTypes: {
		actionColumn: {
			cellRenderer: 'ActionRenderer',
		},
	},
};

export { LocalGridConfig, ServerGridConfig };
